import { AvailableBreak } from '../types/breaks';

/**
 * Updates the availability of breaks based on the earned minutes.
 * @param breaks - The breaks to update.
 * @param earnedMinutes - The earned minutes.
 * @returns The updated breaks.
 */
export function getBreaksWithUpdatedTimeWorkedAvailability({
	breaks,
	earnedMinutes,
}: {
	breaks: AvailableBreak[];
	earnedMinutes: number;
}) {
	return breaks.map((breakItem) => {
		if (
			breakItem.availabilityType === 'hours_worked' &&
			breakItem.availableAfterMinutesWorked
		) {
			return {
				...breakItem,
				availableIn: breakItem.availableAfterMinutesWorked - earnedMinutes,
			};
		}
		return breakItem;
	});
}
